var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-subscription-category-details',{attrs:{"title":_vm.$t('global.profile.subscription_categories.details.title'),"subtitle":'',"entity-id":_vm.subscriptionCategoryId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }